"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/ordermade/v1/ems_service.proto (package spwn.ordermade.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMSOrdermadeService = void 0;
const ems_service_pb_1 = require("./ems_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.ordermade.v1.EMSOrdermadeService
 */
exports.EMSOrdermadeService = {
    typeName: "spwn.ordermade.v1.EMSOrdermadeService",
    methods: {
        /**
         * OM商品一覧取得
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetOrdermadeProducts
         */
        getOrdermadeProducts: {
            name: "GetOrdermadeProducts",
            I: ems_service_pb_1.EMSOrdermadeServiceGetOrdermadeProductsRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetOrdermadeProductsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * OM商品詳細取得
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetOrdermadeProductById
         */
        getOrdermadeProductById: {
            name: "GetOrdermadeProductById",
            I: ems_service_pb_1.EMSOrdermadeServiceGetOrdermadeProductByIdRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetOrdermadeProductByIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 複数商品マスタと1枚画像を選択して商品作成を行う
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.QuickCreateOrdermadeProducts
         */
        quickCreateOrdermadeProducts: {
            name: "QuickCreateOrdermadeProducts",
            I: ems_service_pb_1.EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.Idempotent,
        },
        /**
         * ブランド画像アップロード用Signed URL取得
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetSignedUrlForBrandImageUpload
         */
        getSignedUrlForBrandImageUpload: {
            name: "GetSignedUrlForBrandImageUpload",
            I: ems_service_pb_1.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 商品マスタ一覧取得
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetFactoryBaseItems
         */
        getFactoryBaseItems: {
            name: "GetFactoryBaseItems",
            I: ems_service_pb_1.EMSOrdermadeServiceGetFactoryBaseItemsRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetFactoryBaseItemsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=ems_service_connect.js.map